import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { RestResponse } from 'src/app/model';
import { environment } from 'src/environments/environment';
import { ApiHeaders } from '../headers';

@Injectable()
export class QuestionBankProvider {

  constructor(
    private http: HttpClient
  ) {}

  createBank(schema: string): Observable<RestResponse> {
    return this.http.post<RestResponse>(`${environment.API_URL}/api/question-templates`, schema, ApiHeaders.getOptions());
  }

  getBank(bankId: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(`${environment.API_URL}/api/question-templates/${bankId}`, ApiHeaders.getOptions());
  }

	saveQuestion(bankId: string, groupId: string, schema: string): Observable<RestResponse> {
    return this.http.put<RestResponse>(`${environment.API_URL}/api/question-templates/${bankId}/group/${groupId}`, schema, ApiHeaders.getOptions());
  }

  getBankTemplates():  Observable<RestResponse> {
    return this.http.get<RestResponse>(`${environment.API_URL}/api/question-templates/list`, ApiHeaders.getOptions());
  }

	getQuestionBanks(page: number, query?: string): Observable<RestResponse> {
		return this.http
		.get<RestResponse>(`${environment.API_URL}/api/question-templates?page=${page}` + (query ? '&query=' + encodeURIComponent(query) : ''), ApiHeaders.getOptions());
	}

  deleteQuestion(bankId: string, questionId: number): Observable<RestResponse> {
		return this.http.delete<RestResponse>(`${environment.API_URL}/api/question-templates/${bankId}/questions/${questionId}`, ApiHeaders.getOptions());
  }
}
